import { ReactNode } from "react";

interface FeatureItem {
  icon: ReactNode;
  label: string;
}

interface MarisolFeatureListProps {
  features: FeatureItem[];
  className?: string;
  cols?: number;
}

const FeatureItem = ({ icon, label }: FeatureItem) => (
  <div className="flex flex-col items-center gap-3 text-center max-w-[130px]">
    <div className="w-16 h-16 rounded-full bg-yellow-400 flex items-center justify-center flex-shrink-0">
      {icon}
    </div>
    <p className="text-sm leading-snug">{label}</p>
  </div>
);

export const MarisolFeatureList = ({ features, className = "justify-center gap-6 md:gap-10", cols }: MarisolFeatureListProps) => (
  <div className={cols ? `grid grid-cols-${cols} justify-items-center lg:justify-items-stretch w-full ${className}` : `flex flex-col md:flex-row flex-wrap w-full ${className}`}>                                              {features.map((feature, i) => (
      <FeatureItem key={i} icon={feature.icon} label={feature.label} />
    ))}
  </div>
);
